export const IMAGES = {
  NO: '/images/noImage.jpg',
};
